import { render } from "./MockTest.vue?vue&type=template&id=28ba9c3a&scoped=true"
import script from "./MockTest.vue?vue&type=script&lang=js"
export * from "./MockTest.vue?vue&type=script&lang=js"

import "./MockTest.vue?vue&type=style&index=0&id=28ba9c3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ba9c3a"]])

export default __exports__